<template>
  <div class="flex flex-row justify-end gap-x-4">
    <slot />
  </div>
</template>
